import { Check } from 'lucide-react'
import { CardContainer, CardLabel, CheckIndicator, RadioIndicator } from './styles/OptionCardStyles'

interface OptionCardProps {
  label: string
  isSelected: boolean
  onClick: () => void
  isMultiSelect?: boolean
}

export function OptionCard({ label, isSelected, onClick, isMultiSelect = false }: OptionCardProps) {
  return (
    <CardContainer
      $isSelected={isSelected}
      $isMultiSelect={isMultiSelect}
      onClick={onClick}
      role={isMultiSelect ? 'checkbox' : 'radio'}
      aria-checked={isSelected}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <CardLabel>{label}</CardLabel>
      {isMultiSelect ? (
        <CheckIndicator $isSelected={isSelected}>
          {isSelected && <Check size={14} color="white" strokeWidth={3} />}
        </CheckIndicator>
      ) : (
        <RadioIndicator $isSelected={isSelected} />
      )}
    </CardContainer>
  )
}
